import { adaptedToMatrice, matriceToAdapted } from "../../adapter/matriceAdapter";
import { HttpMethod, initFetch } from "../../utils/fetcher";

export const SAVE_SUCCESS_MATRICES = "SAVE_SUCCESS_MATRICES";
export const SAVE_FAIL_MATRICES = "SAVE_FAIL_MATRICES";
export const UPDATE_SUCCESS_MATRICES = "UPDATE_SUCCESS_MATRICES";
export const UPDATE_FAIL_MATRICES = "UPDATE_FAIL_MATRICES";
export const DELETE_SUCCESS_MATRICES = "DELETE_SUCCESS_MATRICES";
export const DELETE_FAIL_MATRICES = "DELETE_FAIL_MATRICES";
export const SAVE_SUCCESS_MATRICE = "SAVE_SUCCESS_MATRICE";

export function saveMatrice(jsonData, lot) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`matrices`, HttpMethod.POST);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToMatrice(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(res.matrice);
          dispatch({
            type: SAVE_SUCCESS_MATRICE,
            payload: matriceToAdapted(res.matrice),
            lot,
          });
        })
        .catch((err) =>
          dispatch({
            type: SAVE_FAIL_MATRICES,
            error: err,
          })
        );
    });
  };
}

export function updateMatrice(jsonData, id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`matrices/${id}`, HttpMethod.PUT);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToMatrice(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(res.matrice);
          dispatch({
            type: UPDATE_SUCCESS_MATRICES,
            payload: matriceToAdapted(res.matrice),
          });
        })
        .catch((err) =>
          dispatch({
            type: UPDATE_FAIL_MATRICES,
            error: err,
          })
        );
    });
  };
}

export function deleteMatrice(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`matrices/${id}`, HttpMethod.DELETE);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.matrice);
          dispatch({
            type: DELETE_SUCCESS_MATRICES,
            payload: matriceToAdapted(res.matrice),
            id: id,
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: DELETE_FAIL_MATRICES,
            error: err,
          });
        });
    });
  };
}
